import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const EveryRoom: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('every_room');

    return (
        <div className={styles.EveryRoom}>
            <EcoSectionCommon desc={t('desc')} label={t('label')} title={t('title')} />
            <EcoImg
                className="bg"
                pc="https://websiteoss.ecoflow.com/upload/image/1748655468794/pc_Break%20Space%20Limits.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1748655468794/pc_Break%20Space%20Limits.jpg"
            />

            <div className="pad-wrapper">
                <div className="box">
                    <div className="item-title">{t('item1_title')}</div>
                    <div className="item-desc">{t('item1_desc')}</div>
                </div>
                <div className="box">
                    <div className="item-title">{t('item2_title')}</div>
                    <div className="item-desc">{t('item2_desc')}</div>
                </div>
            </div>

            <div className="h5-wrapper">
                <div className="h5-t">
                    <div className="img-wrapper">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748655469149/m_Break%20Space%20Limits_01.jpg" />
                        <div className="text-wrapper">
                            <div className="item-title">{t('item1_title')}</div>
                            <div className="item-desc">{t('item1_desc')}</div>
                        </div>
                    </div>
                </div>
                <div className="h5-b">
                    <div className="img-wrapper">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748656553720/Mask%20group.jpg" />
                        <div className="text-wrapper">
                            <div className="item-title">{t('item2_title')}</div>
                            <div className="item-desc">{t('item2_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EveryRoom;
